import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ModuleRoutingModule,ROUTABLE_COMPONENTS } from './module.routing';
import { MatTableModule,MatSelectModule} from '@angular/material';
import { MatButtonModule, MatInputModule, MatCheckboxModule,MatSlideToggleModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { SidebarModule } from '../../../shared/sidebar/sidebar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { ModuleService } from './shared/module.service';
import { ModuleNewComponent } from './new/module-new.component';
import { ModuleComponent } from './module.component';
import { ModuleListComponent } from './list/module-list.component';
import { ModuleViewComponent } from './view/module-view.component';
import { ModuleEditComponent } from './edit/module-edit.component';

@NgModule({
    imports: [
      BrowserModule,
      MatTableModule,
      ModuleRoutingModule,
      MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
      FormsModule, ReactiveFormsModule,
      FabButtonGroupModule,MatSelectModule,
      SectionBarModule, MatSlideToggleModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule, SidebarModule,
      GridEmptyModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [
        ModuleNewComponent,
        ModuleViewComponent,
        ModuleEditComponent,
        ModuleListComponent,
        ModuleComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [ModuleService],
    bootstrap: []
})
export class ModuleModule {
}
